export const customerId = 'customer_id';
